import React from 'react';
import moment from 'moment';
import { ReactComponent as Ticket } from '../../../../../../../../../resources/images/svg/ticket.svg';
import { ReactComponent as CircleArrow } from '../../../../../../../../../resources/images/svg/circeldArrow.svg';
import { ReactComponent as Location } from '../../../../../../../../../resources/images/svg/location.svg';
import { ReactComponent as Download } from '../../../../../../../../../resources/images/svg/download.svg';
import { ReactComponent as Info } from '../../../../../../../../../resources/images/svg/info.svg';
import useTranslation from '../../../../../../../../hooks/translation/useTranslation';

const ticketActionBtnClass = 'flex gap-3 justify-center items-center flex-1 p-4 bg-transparent rounded-lg border-[1px] border-solid border-gray-gr cursor-pointer flex-wrap !text-[#000000D9]';
function MobileTicketCard({
  purchase, handleDownloadTicket, handleShowDetails,
}) {
  const { trans, currentLanguage } = useTranslation();

  const getStatus = () => {
    if (purchase?.find((ticket) => ticket?.is_refunded)) {
      return 'canceled-tickets';
    }
    return moment().diff(purchase?.[0]?.departure_date) > 0 ? 'expired-tickets' : 'active-tickets';
  };

  const status = getStatus();

  return (
    <div className={`bg-white rounded-2xl p-5 ${status} flex flex-col gap-5`}>
      <div className="flex gap-3 items-center">
        <Ticket className={status === 'active-tickets' ? 'fill-green-gr' : 'fill-gray-gr'} />
        <p className="m-0 text-base">{purchase[0]?.statement?.statement_id}</p>
        <p className="m-0 text-base">{purchase[0]?.train_number}</p>
        <p className="m-0 text-base">{purchase[0]?.ticket_number}</p>
      </div>
      <div className="flex items-start gap-3">
        <CircleArrow className="w-5" />
        <p className="m-0 flex-1 text-base">
          {purchase[0]?.ticket_start_station?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || purchase[0]?.ticket_start_station?.name}
        </p>
        <p className="m-0 flex-1 text-base">
          {moment(purchase[0]?.departure_date).format('DD.MM.YYYY')}
          <br />
          {moment(purchase[0]?.departure_date).format('HH:mm')}
        </p>
      </div>
      <div className="flex items-start gap-3">
        <Location className="w-5" />
        <p className="m-0 flex-1 text-base">
          {purchase[0]?.ticket_end_station?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || purchase[0]?.ticket_end_station?.name}
        </p>
        <p className="m-0 flex-1 text-base">
          {moment(purchase[0]?.arrival_date).format('DD.MM.YYYY')}
          <br />
          {moment(purchase[0]?.arrival_date).format('HH:mm')}
        </p>
      </div>
      <div className="flex justify-between gap-3">
        <button
          type="button"
          className={`${ticketActionBtnClass} ${!purchase?.find((ticket) => !ticket?.is_refunded) && 'hidden'}`}
          onClick={() => handleDownloadTicket(purchase)}
        >
          <Download className="w-4" />
          {' '}
          <p className="m-0">
            {trans('download')}
          </p>
        </button>
        <button
          type="button"
          className={ticketActionBtnClass}
          onClick={handleShowDetails}
        >
          <Info className="w-4" />
          {' '}
          <p className="m-0">
            {trans('details')}
          </p>
        </button>
      </div>
    </div>
  );
}

export default MobileTicketCard;
